import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { GlobalSearchResultTypeEnum } from 'src/portal/search-api/models/global-search-result-type-enum';
import { SuggestService } from 'src/portal/search-api/services/suggest.service';

@Component({
  selector: 'search-filter-checkbox-list',
  templateUrl: './search-filter-checkbox-list.component.html',
  styleUrls: ['./search-filter-checkbox-list.component.scss'],
})
export class SearchFilterCheckboxListComponent implements OnInit, OnChanges {
  @Input() searchType: GlobalSearchResultTypeEnum = GlobalSearchResultTypeEnum.COMPANY;
  @Input() label: string;
  @Input() searchField: string;
  @Input() items: any[] = [];
  @Input() iconName: string;
  @Input() expanded: boolean = false;
  @Output() itemsChange = new EventEmitter<any[]>();

  loading: boolean = true;
  elements: any[] = [];
  dataLoaded: boolean = false;

  constructor(private suggestService: SuggestService) {}

  ngOnInit(): void {
    this.loadSuggestions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.items && this.dataLoaded) {
      this.updateSelection();
    }
  }

  private loadSuggestions(): void {
    this.suggestService
      .suggest({
        entity: this.searchType,
        field: this.searchField,
        search: '',
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((res) => {
        this.elements = this.sortElements(res);
        this.dataLoaded = true;
        this.updateSelection();
      }, error => {
        console.error('Ошибка при загрузке данных:', error);
        this.elements = [];
        this.dataLoaded = true;
      });
  }

  private sortElements(elements: any[]): any[] {
    if (this.searchField === 'employeeRange') {
      const order = [
        'Micro (1-20 Employees)',
        'Small (21-100 Employees)',
        'Medium (101-500 Employees)',
        'Large (1001-5000 Employees)',
        'XLarge (5001+ Employees)'
      ];
      return elements.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
    } else if (this.searchField === 'revenueRange') {
      const order = [
        'Less than $1 Million',
        '$1 - 9.99 Million',
        '$10 - 49.99 Million',
        '$50 - 99.99 Million',
        '$100 - 999.99 Million',
        '$1+ Billion'
      ];
      return elements.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
    }
    return elements;
  }

  private updateSelection(): void {
    if (this.elements.length === 0) {
      console.warn('Массив elements пуст, пропускаем обновление выбора.');
      return;
    }

    this.elements.forEach(item => {
      item.checked = this.items.includes(item.name);
    });
  }

  onSelectionChanged(itemName: string, event: any): void {
    if (event.checked) {
      this.items.push(itemName);
    } else {
      const index = this.items.indexOf(itemName);
      if (index >= 0) {
        this.items.splice(index, 1);
      }
    }
    this.itemsChange.emit(this.items);
  }
}
